// Prompt AJ - Cambio 3 (2026-09-23): estado de conectividad compartido en
// toda la app. Se marca "sin conexión" cuando navigator.onLine pasa a false
// O cuando una llamada a la API falla por red (sin respuesta del server,
// no un simple 4xx/5xx). Se limpia con el evento "online" del navegador o
// en cuanto CUALQUIER pedido a la API vuelve a tener respuesta.
const listeners = new Set();
let offline = typeof navigator !== "undefined" ? !navigator.onLine : false;

function notify() {
  listeners.forEach((fn) => fn(offline));
}

export function subscribeConnectivity(fn) {
  listeners.add(fn);
  fn(offline);
  return () => listeners.delete(fn);
}

export function markNetworkError() {
  if (!offline) { offline = true; notify(); }
}

export function markNetworkOk() {
  if (offline) { offline = false; notify(); }
}

if (typeof window !== "undefined") {
  window.addEventListener("online", markNetworkOk);
  window.addEventListener("offline", markNetworkError);
}
